import { combineReducers } from 'redux'
import me from './me'
import error from './error'
import login from './login'
import signup from './signup'
import resetPassword from './resetPassword'
import forgotPassword from './forgotPassword'


const combined = combineReducers({
  me,
  error,
  login,
  signup,
  resetPassword,
  forgotPassword
})

export default (state: unknown, action: Record<string, unknown> = {}) => {
  return combined(state as never, action as never)
}
